import React from 'react';
import { useDrop } from 'react-dnd';

const DroppableContainerLayer = ({ onDropSuccess, onClickHandler }) => {
  const [
    {
      /*canDrop, isOver*/
    },
    drop,
  ] = useDrop({
    accept: 'IMG',
    drop: (props, monitor) => {
      const item = monitor.getItem();
      if (onDropSuccess) {
        const clientOffset = monitor.getClientOffset();
        onDropSuccess({ content: item, offsett: clientOffset });
      }

      return item;
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  return (
    <>
      <div
        onMouseDown={() => {
          onClickHandler();
        }}
        ref={drop}
        id="drop-container"
      />
    </>
  );
};
export default DroppableContainerLayer;

// <div id="drop-text">Drop images here!</div>
